import React from "react";
import { Plus } from "react-feather";
import { Button } from "reactstrap";

const OrderButton = ({ setProjectInfoModel, projectInfoModel }) => {
  return (
    <>
      {" "}
      <Button.Ripple
        // color="primary "
        className="order-project-btn"
        onClick={() => setProjectInfoModel(!projectInfoModel)}
      >
        <Plus size={14} />
        <span className="align-middle ms-25">Order New Project</span>
      </Button.Ripple>
    </>
  );
};

export default OrderButton;
